import { useEffect, useState } from "react";
import { useApi } from "./api";

export interface Streak {
  dayStreak: number;
  lessonRun: number;
  lastCompletedAt: number | null;
}

export type StreakState =
  | { status: "loading" }
  | { status: "error" }
  | { status: "ready"; streak: Streak };

// trigger: pass Date.now() after markComplete resolves to force a refetch
// that includes the just-completed lesson.
export function useStreak(trigger?: number): StreakState {
  const { apiFetch } = useApi();
  const [state, setState] = useState<StreakState>({ status: "loading" });
  useEffect(() => {
    let cancelled = false;
    const tz = -new Date().getTimezoneOffset(); // minutes east of UTC
    setState({ status: "loading" });
    apiFetch<Streak>(`/api/streak?tz=${tz}`)
      .then((streak) => {
        if (!cancelled) setState({ status: "ready", streak });
      })
      .catch(() => {
        if (!cancelled) setState({ status: "error" });
      });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);
  return state;
}
